// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceAdvanced_wrapper__-+huE"};